import { api } from "@/api";

export async function addPinnedMarket(marketGroup: number) {
  const res = await api.client.post("/pinned-markets", { marketGroup });
  return res.data;
}
